module.exports = __webpack_public_path__ + "img/ic_comment_success.f2dd08a8.svg";